import React, { memo } from 'react';
import CompareIcon from 'mdi-react/ScaleBalanceIcon';
import { useAppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

type Props = {
  active: boolean;
  activate: () => void;
  deactivate: () => void;
};

const CompareProductsToggle = ({ active, activate, deactivate }: Props) => {
  const { t } = useAppContext();
  const label = active
    ? t('product', 'product-compare.cancel-compare')
    : t('product', 'product-compare.choose-products');

  return (
    <S.Tooltip placement="left" title={label}>
      <S.CompareProductButton
        onClick={active ? deactivate : activate}
        aria-label={label}
      >
        <S.CompareIconWrapper active={active}>
          <CompareIcon size={24} />
        </S.CompareIconWrapper>
      </S.CompareProductButton>
    </S.Tooltip>
  );
};

export default memo(CompareProductsToggle);
